module.exports = __webpack_public_path__ + "static/media/checkMark.25c34794.svg";